import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { productFamilyIdFormat, productIdFormat } from "../ids";

export enum ListingType {
  General = "general",
  Shopify = "shopify",
  ChatGpt = "chatgpt",
  Amazon = "amazon",
  Walmart = "walmart",
  Perplexity = "perplexity",
  RedoMarketplace = "redo-marketplace",
  Ebay = "ebay",
  GoogleShopping = "google-shopping",
}
export const ListingTypeSchema = createEnum(ListingType);

export const BaseProductFamilyListingSchema = z.object({
  listingType: ListingTypeSchema,
  productFamilyId: productFamilyIdFormat.schema,
});

export const BaseProductListingSchema = z.object({
  listingType: ListingTypeSchema,
  productId: productIdFormat.schema,
});
